export var source = "query AvailablePlansToUpgrade {\n  plans {\n    name\n    monthCount: billingPeriod\n    scentCount: productsPerPeriod\n    shippingPeriod\n    totalPrice\n    productPrice\n    selected\n  }\n}";
export default source;